{
  "name": "@ns/data-add-record",
  "version": "1.2.0",
  "authorable": true,
  "description": "Add a record to a data set from the fields the workflow maps, while the job is open. The job can hand on only the record it added. A second set it covers is what its reference fields pick from.",
  "inputs": {
    "SET": {
      "type": "string",
      "ref": "dataSet",
      "access": "CONTRIBUTE"
    },
    "FIELDS": {
      "type": "array",
      "fieldsOf": "SET"
    },
    "LINKED_SET": {
      "type": "string",
      "ref": "dataSet",
      "access": "READ",
      "optional": true,
      "linked": true
    },
    "LINKED_FIELDS": {
      "type": "array",
      "fieldsOf": "LINKED_SET",
      "optional": true
    },
    "PROMPT": {
      "type": "string",
      "optional": true
    }
  },
  "outcomes": {
    "added": {
      "inputs": {
        "RECORD": {
          "type": "string",
          "ref": "dataRecord"
        }
      }
    }
  }
}
